import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { theme, ButtonAnt, Text } from '@pfmam/pfmam';
import ListWrapperComponent from '../../../common/components/listWrapper';
import { Box } from '../../../styles/globalStyle';
import { GetBeneficiaryAddress } from '../../../actions/actions';
const ListWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.grey};
  transition: 0.3s;
  &:last-of-type {
    border-bottom: 0;
  }
  .strong {
    font-family: 'Inter Semibold';
  }
`;
const EditBtn = styled(ButtonAnt)`
  border: 1px solid ${theme.colors.grey};
  border-radius: 2px;
  height: 52px;
  padding: 12px 24px;
  color: ${theme.colors.black_secondary};
  font-size: ${theme.font_size.size_xl};
  display: block;
  width: 100%;
  margin-top: 48px;
  &:hover {
    color: ${theme.colors.black_secondary};
    border-color: ${theme.colors.grey};
  }
`;

// The API returns PascalCase keys, older payloads may use camelCase.
const BENEFICIARY_ADDRESS_LABELS = [
  { label: 'Building Number', keys: ['BuildingNumber', 'buildingNumber'] },
  { label: 'Street Name', keys: ['StreetName', 'streetName'] },
  { label: 'Building Name', keys: ['BuildingName', 'buildingName'] },
  { label: 'Department', keys: ['Department', 'department'] },
  { label: 'Floor Number', keys: ['FloorNumber', 'floorNumber'] },
  { label: 'Room Number', keys: ['RoomNumber', 'roomNumber'] },
  { label: 'City', keys: ['City', 'city'] },
  { label: 'State', keys: ['State', 'state'] },
  { label: 'Zip Code', keys: ['ZipCode', 'zipCode'] },
  { label: 'County', keys: ['County', 'county'] },
  { label: 'Country', keys: ['Country', 'country'] },
];

const getAddressValue = (address, keys) => {
  if (!address) return '- - - -';
  const key = keys.find((k) => address[k] !== null && address[k] !== undefined && address[k] !== '');
  return key ? address[key] : '- - - -';
};

const DetailsModalContent = ({
  webuserAccessType,
  canEditWiresAccount,
  selectedRecord,
  handleModalCancel,
  type,
  addEditAccountObject,
  setAddEditAccountObject,
  isGlobalSettingsPage,
}) => {
  const history = useHistory();
  const permissions =
    type === 'Participant'
      ? selectedRecord.peerPermissions
      : selectedRecord.permissions;
  const [beneficiaryAddress, setBeneficiaryAddress] = useState(null);

  useEffect(() => {
    if (type !== 'Wire' || !selectedRecord.wireInstructionID) {
      setBeneficiaryAddress(null);
      return;
    }

    let isActive = true;
    GetBeneficiaryAddress(selectedRecord.wireInstructionID)
      .then((response) => {
        if (!isActive) return;
        const data = response.data;
        const address = Array.isArray(data) ? data[0] : data;
        setBeneficiaryAddress(address || null);
      })
      .catch((error) => {
        console.log('Error fetching beneficiary address:', error);
        if (isActive) setBeneficiaryAddress(null);
      });

    return () => {
      isActive = false;
    };
  }, [type, selectedRecord.wireInstructionID]);

  return (
    <>
      {type === 'Participant' && (
        <ListWrapperComponent
          label="Participant Name"
          value={selectedRecord.participantName}
          className="auto-width-text"
        />
      )}
      {type !== 'Participant' ? (
        <>
          <ListWrapperComponent
            label="Bank Name"
            value={selectedRecord.bankName}
            className="auto-width-text"
          />
          {type === 'Wire' ? (
            <ListWrapperComponent
              label="Bank City and State"
              value={selectedRecord.bankCity + ', ' + selectedRecord.bankState}
            />
          ) : null}
          <ListWrapperComponent
            label="Nickname"
            value={
              selectedRecord.nickName ? selectedRecord.nickName : '- - - -'
            }
            className="auto-width-text"
          />
          <ListWrapperComponent
            label={
              type === 'ACH'
                ? 'ACH, ABA, or Routing #'
                : 'ABA or Routing Number'
            }
            value={selectedRecord.routing ? selectedRecord.routing : '- - - -'}
            className="auto-width-text"
          />
        </>
      ) : null}
      <ListWrapperComponent
        label={
          type === 'Wire' ? 'Bank Account Number' : 'Bank Account Number'
        }
        value={selectedRecord.accnumber ? selectedRecord.accnumber : '- - - -'}
        className="auto-width-text"
      />
      {type === 'ACH' ? (
        <>
          <ListWrapperComponent
            label="Name of Account"
            value={
              selectedRecord.nameOnAccount
                ? selectedRecord.nameOnAccount
                : '- - - -'
            }
            className="auto-width-text"
          />
          <ListWrapperComponent
            label="Account Type"
            value={selectedRecord.acctype ? selectedRecord.acctype : '- - - -'}
            className="auto-width-text"
          />
          <ListWrapperComponent
            label="Addendum Purchase Information"
            value={
              selectedRecord.addendumPurchaseDescription
                ? selectedRecord.addendumPurchaseDescription
                : '- - - -'
            }
            className="auto-width-text"
          />
          <ListWrapperComponent
            label="Addendum Redemption Information"
            value={
              selectedRecord.addendumRedemptionDescription
                ? selectedRecord.addendumRedemptionDescription
                : '- - - -'
            }
            className="auto-width-text"
          />
        </>
      ) : null}
      {type === 'Wire' ? (
        <>
          <ListWrapperComponent
            label="Beneficiary Name"
            value={selectedRecord.beneficiaryName}
          />
          <ListWrapperComponent
            label="Beneficiary Account Number"
            value={
              selectedRecord.beneficiaryAccNumber
                ? selectedRecord.beneficiaryAccNumber
                : '- - - -'
            }
            minwidth="239px"
            maxwidth="239px"
          />
          <ListWrapperComponent
            label="Beneficiary Details"
            value={
              selectedRecord.beneficiaryDetails
                ? selectedRecord.beneficiaryDetails
                : '- - - -'
            }
          />
          <Text
            label="Beneficiary Address"
            padding="24px 0 4px 0"
            color={`${theme.colors.black_secondary}`}
            fontSize={`${theme.font_size.size_xl}`}
            lineheight="24px"
            className="strong"
          />
          {BENEFICIARY_ADDRESS_LABELS.map((field) => (
            <ListWrapperComponent
              key={field.label}
              label={field.label}
              value={getAddressValue(beneficiaryAddress, field.keys)}
              className="auto-width-text"
            />
          ))}
        </>
      ) : null}
      {isGlobalSettingsPage ? (
        <ListWrapper>
          <Box minwidth="215px" maxwidth="215px" textalign="left">
            <Text
              label={'Account Permissions'}
              padding="14px 0 10px 0"
              color={`${theme.colors.grey_tertiary}`}
              fontSize={`${theme.font_size.size_xl}`}
              lineheight="24px"
            />
          </Box>
          <Box minwidth="215px" maxwidth="215px" textalign="right">
            {permissions && permissions.length ? (
              permissions.map((permission) => {
                return (
                  <Text
                    label={permission}
                    color={`${theme.colors.black_secondary}`}
                    fontSize={`${theme.font_size.size_xl}`}
                  />
                );
              })
            ) : (
              <Text
                label="- - - -"
                padding="14px 0 14px 0"
                color={`${theme.colors.black_secondary}`}
                fontSize={`${theme.font_size.size_xl}`}
              />
            )}
          </Box>
        </ListWrapper>
      ) : null}
     {webuserAccessType == 0 && canEditWiresAccount  ? ( <EditBtn
        label="Edit Account"
        type="secondary"
        onClick={() => {
          if(type==='Wire')
          {
            handleModalCancel('details');
            history.push("/edit-wire", { wireInstructionID: selectedRecord.wireInstructionID,canNavigateInstruction:1});
          }
          else if(type==='ACH'){
            handleModalCancel('details');
            history.push("/edit-ach", { achInstructionID: selectedRecord.achInstructionID,canNavigateInstruction:1});
          }

        }}
      />):null}
    </>
  );
};

export default DetailsModalContent;
